<template>
  <div
    v-loading="loading"
    class="analysis"
  >
    <div class="activity-trend">
      <div class="title">
        近15天客户活跃度趋势
      </div>
      <div class="activity-trend-chart">
        <template v-if="data.length > 0">
          <mk-stacked
            :data="data"
            :options="options"
          ></mk-stacked>
        </template>
        <template v-else>
          <div class="no-data">
            暂无数据
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Analysis',
  props: {
    clueId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 是否正在加载
      loading: false,
      // 图标的数据
      data: [],
      // 图表的配置
      options: {
        chart: {
          height: 400,
          width: 600,
          scale: {
            year: {
              type: 'linear',
              tickInterval: 50
            }
          }
        },
        axis: [
          {
            dataTime: 'day'
          },
          {
            name: 'attachCount'
          }
        ],
        geom: [
          {
            type: 'area',
            position: 'day*attachCount',
            color: 'platformCn'
          },
          {
            type: 'line',
            position: 'day*attachCount',
            color: 'platformCn',
            size: 2
          }
        ]
      }
    }
  },
  mounted () {
    this.wxclueStatisticsGet()
  },
  methods: {
    async wxclueStatisticsGet () {
      let clueID = this.clueId
      // let clueID = '4be12f82-f171-11e9-9aa8-88e9fe6ba529'
      this.loading = true
      let res = await BIZAPIS.StatisticsApi.wxclueStatisticsGet({
        clueID
      })
      this.loading = false
      if (res.success) {
        res.data.data = res.data.data ? res.data.data : []
        res.data.data.forEach(item => {
          item.platformCn = this.platformFormat(item.platform)
        })
        this.data = res.data.data
      }
    },
    platformFormat (platform) {
      switch (platform) {
        case 'WPN':
          return 'H5推广'
        case 'mini':
          return '小程序'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.analysis {
  background-color: #fafafa;
  padding: 10px 20px;

  .activity-trend {
    background-color: #fff;

    .title {
      height: 39px;
      line-height: 39px;
      padding-left: 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #e8e8e8;
    }

    .title::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 13px;
      border-radius: 1px;
      background-color: #009cff;
    }
  }

  .activity-trend-chart {
    margin-top: 35px;
  }

  .no-data {
    margin: 0 20px;
    padding-bottom: 20px;
  }
}
</style>
